// Accent colors - expressive communication, notify, hovers, etc
const accentBlue = '#ecf1fd';
const accentBlue2 = '#215585';
const accentRed = '#ef565f';
const accentYellow = '#edcf66';
const accentGreen1 = '#3DDB69';
const accentGreen2 = '#076105';

// Background blue - bg focus
const backgroundFocusBlue = '#f9fbff';
// rgb(249,251,255)

// Background white - bg
const backgroundWhite = '#ffffff';
// rgb(255,255,255)
const black = '#000000';

// Destructive red - prevent or display errors
const destructiveRed1 = '#de1a1a';
const destructiveRed2 = '#ad1414';
const destructiveRed3 = '#730d0d';

// Disabled elements
const disabledGray1 = '#ececed';
const disabledGray2 = '#b5b5b6';

// Focused input
const focusPurple = '#b770fe';

// Neutral gray
const neutralGray = '#d8d8d9';
const neutralGray1 = '#F5F5F6';
const neutralGray3 = '#323232';

// Paragraph Baseline - text
const paragraphBaseline = '#474748';

// Paragraph Placeholder - sub header and disabled text
const paragraphPlaceholder = '#979899';

// Primary blue - btns
const primaryBlue = '#2a5bdf';
// rgb(42,91,223)

// Primary hover blue 1 - btns
const primaryHoverBlue1 = '#c0d1ff';
// rgb(192,209,255)

// Primary hover blue 2 - btns
const primaryHoverBlue2 = '#2046ad';
// rgb(32,70,173)

// Primary pressed blue - btns
const primaryPressedBlue = '#152e73';
// rgb(21,46,115)

// Secondary blue - Initials in avatars
const secondaryBlue = '#7f9cec';
// rgb(127,156,236)

const purple = '#B666FF';

export {
  accentBlue,
  accentBlue2,
  accentRed,
  accentYellow,
  accentGreen1,
  accentGreen2,
  backgroundFocusBlue,
  backgroundWhite,
  black,
  destructiveRed1,
  destructiveRed2,
  destructiveRed3,
  disabledGray1,
  disabledGray2,
  focusPurple,
  neutralGray,
  neutralGray1,
  neutralGray3,
  paragraphBaseline,
  paragraphPlaceholder,
  primaryBlue,
  primaryHoverBlue1,
  primaryHoverBlue2,
  primaryPressedBlue,
  purple,
  secondaryBlue,
};
